import type React from 'react';

import type { BrowserInfo } from '@/types/Diagnostics';

interface BrowserTabProps {
  browserInfo: BrowserInfo | null;
}

export default function BrowserTab({ browserInfo }: BrowserTabProps): React.JSX.Element {
  if (browserInfo === null) {
    return <p className="text-sm text-muted-foreground">Browser info unavailable.</p>;
  }

  const rows: Array<{ label: string; value: string }> = [
    { label: 'User Agent', value: browserInfo.userAgent },
    { label: 'Language', value: browserInfo.language },
    { label: 'Viewport', value: `${browserInfo.viewportWidth}x${browserInfo.viewportHeight}` },
    { label: 'Online', value: browserInfo.online ? 'yes' : 'no' },
  ];

  return (
    <dl className="space-y-2 text-sm">
      {rows.map((row) => (
        <div key={row.label} className="flex justify-between gap-4">
          <dt className="flex-shrink-0 text-muted-foreground">{row.label}</dt>
          <dd className="break-all text-right font-medium text-foreground">{row.value}</dd>
        </div>
      ))}
    </dl>
  );
}
